import React from "react"
import Header from "../../../header"
import Footer from "../../../footer"

function AuthorsReviewer() {
    return (
        <div className="main-wrapper">
            <Header />
            <div style={{ marginTop: '5%' }}>
                {/* <Bannerpage /> */}
                {/*  */}
                <div className="inner-banner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="instructor-wrap border-bottom-0 m-0">
                                    <div className="about-instructor align-items-center"></div>
                                </div>
                                <h4>{"Journals Feed"}</h4>

                                <div
                                    className="course-info d-flex align-items-end border-bottom-0 m-0 p-0 "
                                    style={{ justifyContent: "end" }}
                                >
                                    <div className="cou-info">
                                        <h4 style={{ textAlign: "center" ,color:"white"}}>
                                            Authors,Reviewers & Editors
                                        </h4  >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt-4">
                <h4><strong>Instructions to Authors</strong></h4>
                <p>
                    Our journals are all open access. Each article published by <strong>JournalsFeed Publishing</strong> house follows a specific format.
                </p>

                <h4>Article Categories</h4>

                <ul>
                    <li>
                        <strong>Original Articles:</strong> reports of data from original research.
                    </li>
                    <li>
                        <strong>Reviews:</strong> comprehensive, authoritative descriptions of any subject within the scope of the journal. These articles are usually written by experts in the field who have been invited by the Editorial Board.
                    </li>
                    <li>
                        <strong>Case reports:</strong> reports of clinical cases that can be educational, describe a diagnostic or therapeutic dilemma, suggest an association or present an important adverse reaction. Authors should clearly describe the clinical relevance or implications of the case. All case report articles should indicate that informed consent to publish the information has been granted from the patients or their guardians.
                    </li>
                    <li>
                        <strong>Commentaries:</strong> short, focused, opinion articles on any subject within the scope of the journal. These articles are usually related to contemporary issues, such as recent research findings, and are often written by opinion leaders.
                    </li>
                    <li>
                        <strong>Methodology articles:</strong> present a new experimental method, test or procedure. The method described may be new, or may offer a better version of an existing method.
                    </li>
                    <li>
                        <strong>Letter to the Editor:</strong> these can take three forms: a substantial re-analysis of a previously published article; a substantial response to such a re-analysis from the authors of the original publication; or an article that may not cover ‘standard research’ but that may be relevant to readers.
                    </li>
                </ul>

                <h4>Manuscript Submission Guidelines</h4>

                <p>
                    One author must be designated as the corresponding author, responsible for the manuscript throughout the submission and peer review process. To streamline publication and reduce administrative costs, <strong>JournalsFeed Publishing</strong> only accepts online submissions. Please note that an <strong>article processing charge</strong> applies to all accepted manuscripts.
                </p>

                <p>
                    As part of your submission, you must include a <strong>cover letter</strong> explaining why your manuscript is suitable for publication in the journal and disclosing any potential <strong>competing interests</strong>.
                </p>

                <p>
                    Additionally, you must provide the <strong>names and email addresses of two suggested peer reviewers</strong>. These individuals should be recognized experts in the field, with no recent collaborations (within the last five years), institutional affiliations, or shared authorship with any of the manuscript’s authors. These suggestions will be considered alongside reviewers selected by the Editorial Board.
                </p>

                <p>
                    Files may be uploaded individually or in batches. Please refer to the list of acceptable file formats below. You may also include additional files such as videos, animations, or original datasets to support your submission.
                </p>

                <h6>Here are the files required for submission:</h6>
                <ul>
                    <li>
                        <strong>Title page</strong>
                        <ul>
                            <li>Formats: DOC</li>
                            <li>Must be a separate file, not embedded in the main manuscript.</li>
                        </ul>
                    </li>
                </ul>


                <ul>
                    <li>
                        <strong>Main manuscript</strong>
                        <ul>
                            <li>Format: DOC</li>
                            <li>Tables less than 2 pages each (about 90 rows) should be included at the end of the manuscript.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Figures</strong>
                        <ul>
                            <li>Formats: PPT, DOC, PDF</li>
                            <li>All figures must be sent together as one separate file, not embedded in the main manuscript.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Cover letter</strong>
                        <ul>
                            <li>Format: DOC</li>
                            <li>Must be a separate file, not embedded in the main manuscript.</li>
                        </ul>
                    </li>
                </ul>

                <h6>The title page should:</h6>
                <ul>
                    <li>Provide the title of the article</li>
                    <li>List the full names, institutional addresses, and email addresses for all authors</li>
                    <li>Indicate the corresponding author</li>
                </ul>

                <h4 className="mt-4">Acknowledgments, Funding, and Conflict of Interest Declarations</h4>

                <ul>
                    <li>
                        <strong>Acknowledgments:</strong> This section should list individuals who made significant contributions to the work. Authors must obtain <em>written and signed permission</em> from all individuals named in the acknowledgments, as their inclusion may imply endorsement of the content. These permissions must be submitted to the Editorial Office.
                    </li>
                    <li>
                        <strong>Sources of Funding:</strong> All relevant sources of financial support must be clearly stated. <em>Full names</em> of funding agencies should be used—do not use abbreviations or acronyms without explanation.
                    </li>
                    <li>
                        <strong>Conflict of Interest:</strong> Any potential conflicts must be disclosed in the cover letter at the time of submission. If none exist, please include the statement: <em>&quot;Conflict of Interest: None to report.&quot;</em> Conflicts include, but are not limited to, ties to pharmaceutical companies, medical device manufacturers, or other entities whose products or services relate to the manuscript content. This may involve employment, stock ownership, advisory roles, board memberships, or financial compensation such as honoraria or research grants. The corresponding author is responsible for collecting and reporting conflict of interest disclosures from all co-authors.
                    </li>
                </ul>

                <h4 className="mt-4">Tables and Figures</h4>

                <ul>
                    <li>
                        <strong>Tables:</strong><br /> Each table must be numbered consecutively (Table 1, Table 2, etc.) and cited in order within the text. Titles should appear above each table and be no longer than 15 words. All tables should be placed at the end of the manuscript document in A4 Portrait or Landscape format and created using the &apos;Table &apos; function of a word processor to maintain proper alignment of data.<br /><br />Tables should not be submitted as figures or spreadsheets. Large datasets or tables exceeding landscape dimensions can be uploaded separately as additional files. These supplementary files will not appear in the final published PDF, but links to them will be provided.
                    </li>
                </ul>

                <ul>
                    <li>
                        <strong>Figures:</strong><br />All figures must be submitted in a single, separate file in .DOC, .PDF, or .PPT format with a minimum resolution of 300 dpi. Figures should not be embedded in the main manuscript file. Multi-part figures must be combined into one composite image per figure.<br />There is no charge for using color images. Figure legends should be included at the end of the main manuscript document—not within the figure file itself—and should include:
                        <br />
                        <ul>
                            <li>Formats: DOC</li>
                            <li>Must be a separate file, not embedded in the main manuscript.</li>
                        </ul>
                        <br />
                        Authors are responsible for obtaining permission to reuse any previously published tables or figures.

                    </li>
                </ul>
                <ul>
                    <li>
                        <strong>References:</strong><br /> All references, including web links, must be numbered consecutively in square brackets [1], [2], etc., according to the order in which they appear in the text. References should follow the National Library of Medicine (NLM) formatting style. Each citation must have a unique reference number. Please avoid excessive or unnecessary referencing.
                        <br /><br />
                        All references, including web links, must be numbered consecutively in square brackets [1], [2], etc., according to the order in which they appear in the text. References should follow the National Library of Medicine (NLM) formatting style. Each citation must have a unique reference number. Please avoid excessive or unnecessary referencing.
                        <br /><br />
                        Journal titles should be abbreviated according to the Index Medicus/MEDLINE standards.
                        <br /><br />
                        In the reference list, include all named authors. However, we will list first author followed by “et al.” Any in-press articles cited must be made available to reviewers upon request by the editorial office.

                    </li>
                </ul>

                <ul>
                    <li>
                        <strong>Language and Style</strong><br />JournalsFeed Publishing accepts manuscripts only in English. Authors may use either U.S. English or British English spelling, but mixing the two within a manuscript is not permitted.
                        <br /><br />
                        Manuscripts will not be edited for language or style, and reviewers may recommend rejection if the text contains significant grammatical errors. Therefore, authors are encouraged to write clearly and simply, and to have their work reviewed by colleagues prior to submission.
                        <br /><br />
                        In-house copyediting is limited. Non-native English speakers are encouraged to consider using our professional copyediting services.
                        <br /><br />
                        Use abbreviations sparingly and always define them upon first use.
                    </li>
                </ul>



                <p><strong>In addition,</strong></p>
                <ul>
                    <li>Please use double-line spacing.</li>
                    <li>Use justified margins, without hyphenating words at line breaks.</li>
                    <li>Use hard returns only to end headings and paragraphs, not to rearrange lines.</li>
                    <li>Capitalize only the first word and proper nouns in the title.</li>
                    <li>Number all pages.</li>
                    <li>Use the correct reference format.</li>
                    <li>Format the text in a single column.</li>
                    <li>
                        Greek and other special characters may be included. If you are unable to reproduce a particular character, please type out the name of the symbol in full. Please ensure that all special characters are embedded in the text; otherwise, they will be lost during PDF conversion.
                    </li>
                    <li>SI units should be used throughout (“litre” and “molar” are permitted).</li>
                </ul>

                <h4 className="mt-4">Word Count and Abstract Guidelines</h4>
                <p>
                    There is no strict word limit for Original Articles, Methodology Articles, and Reviews; however, authors are encouraged to be concise. Commentaries and Case Reports should be between 800 and 1,500 words. Letters to the Editor may range from 1,000 to 3,000 words.
                    There are no limits on the number of figures, tables, additional files, or references included. Figures and tables must be numbered sequentially as they appear in the text. Authors should provide all relevant supporting data with their submission.
                </p>
                <p>
                    Abstracts for Original and Methodology Articles must be structured into Background, Methods, Results, and Conclusions and should not exceed 250 words. Reviews require an unstructured, single-paragraph summary of no more than 350 words covering the main points.
                    Commentaries and Case Reports should have a brief, unstructured summary of no more than 150 words. Letters to the Editor should include an unstructured summary of up to 250 words.
                </p>
                <p>
                    Abbreviations should be minimized and not used in abstracts, and references must not be cited within the abstract. If applicable, please include your trial registration number immediately after the abstract.
                </p>

                <h6 className="mt-3"><strong>Below the abstract, provide 3 to 10 keywords.</strong></h6>

                <p>
                    Accession numbers for nucleic acid or protein sequences, or atomic coordinates referenced in the manuscript, should be listed in square brackets along with the corresponding database name.
                </p>

                <h4 className="mt-4">Initial Review Process</h4>
                <p>
                    Submitted manuscripts undergo an initial assessment by the editor-in-chief and an associate editor. A prompt decision will be made on whether the manuscript merits formal peer review by two or more expert reviewers, or if it should be rejected without external review.
                </p>

                <p>
                    Decision is based on the manuscript’s quality, scientific rigor, and the presentation and analysis of data. Typically, about 70% of submissions proceed to formal peer review, while approximately 30% are rejected at this stage.
                </p>

                <h4 className="mt-4">Instructions for Revised Submissions</h4>
                <ul>
                    <li>
                        Please submit a copy of the revised manuscript with all changes clearly indicated, using either tracked changes or highlighting.
                    </li>
                    <li>
                        In your detailed response to the reviewers’ comments, specify the page number(s), paragraph(s), and/or line number(s) where each revision has been made.
                    </li>
                    <li>
                        Address each reviewer’s comment individually, clearly outlining the changes made in response. If you choose not to implement a suggested change, please explain your reasons, and note any additional modifications made.
                    </li>
                    <li>
                        Revised manuscripts not received within two months will be withdrawn administratively. To be reconsidered, the manuscript must be resubmitted as a new submission. Extensions may be granted at the editors’ discretion, particularly if substantial new data are needed, and efforts will be made to retain the original reviewers whenever possible.
                    </li>
                </ul>

                <h4 className="mt-4">Guide for reviewers</h4>
                <p>
                    All submitted manuscripts are typically evaluated by at least two independent experts. Peer reviewers are asked to provide a recommendation—accept, revise, or reject—and to report any concerns regarding potential author misconduct, including plagiarism or unethical practices.
                </p>
                <p>
                    JournalFeed Publishing uses a double-blind peer review process, ensuring that both authors and reviewers remain anonymous throughout the review.
                </p>
                <p>
                    Manuscripts are assessed primarily on their scientific validity and logical coherence, as determined by both peer reviewers and the editorial team. Reviewers may also be asked to evaluate the clarity and readability of the manuscript. Submissions will not be sent for peer review if they fall outside the journal’s scope or if the quality of writing, particularly in English, is below acceptable standards.
                </p>
                <p>
                    Authors who are non-native English speakers are strongly encouraged to use language editing services prior to submission. Please note that using such services is at the author’s expense and does not guarantee acceptance.
                </p>

                <h4 className="mt-4">Points to Consider</h4>
                <p>
                    Reviewers are expected to provide thorough, constructive feedback to assist editors in making publication decisions and to help authors enhance their manuscript. A critical responsibility is to assess whether the study contains significant methodological issues that would prevent publication or if additional data or experiments are necessary to substantiate the authors’ conclusions. When applicable, reviewers should cite relevant references to support their evaluations.
                </p>
                <p>
                    Reviewers should also clearly indicate whether any recommended revisions fall under ‘major’ or ‘minor’ categories. Major revisions are generally warranted when the current data do not adequately support the conclusions, when further analysis could alter key findings, or when the methodology is flawed or includes statistical inaccuracies.
                </p>

                <div>
                    <h4>Is the question posed important and well defined?</h4>
                    <p>The research question presented by the authors should be clearly stated and easy to understand. Reviewers are encouraged to evaluate and comment on the study’s originality and significance within its academic or clinical field. After reading the manuscript, reviewers should consider whether the study offers new insights and whether its conclusions are clearly supported by the findings.</p>

                    <h4>Are the data sound and well controlled?</h4>
                    <p>If you feel that inappropriate controls have been used, please say so, indicating the reasons for your concerns, and suggest alternative controls where appropriate. If you feel that further experimental/clinical evidence is required to substantiate the results, please provide details.</p>

                    <h4>Is the interpretation (discussion and conclusion) well balanced and supported by the data?</h4>
                    <p>The interpretation should discuss the relevance of all the results in an unbiased manner. Are the interpretations overly positive or negative? Conclusions drawn from the study should be valid and result directly from the data shown, with reference to other relevant work as applicable. Have the authors provided references wherever necessary?</p>

                    <h4>Are the methods appropriate and well described, and are sufficient details provided to allow others to evaluate and/or replicate the work?</h4>
                    <p>Please remark on the suitability of the methods for the study, which should be clearly described and reproducible by peers in the field.</p>
                    <p>If statistical analyses have been performed, specify whether they need to be assessed specifically by an additional reviewer with statistical expertise.</p>

                    <h4>What are the strengths and weaknesses of the methods?</h4>
                    <p>Please comment on any improvements that could be made to the study design to enhance the quality of the results. If any additional experiments are required, please give details. If novel, experimental techniques were used, please pay special attention to their reliability and validity.</p>

                    <h4>Can the writing, organization, tables and figures be improved?</h4>
                    <p>Please comment if you consider the quality of the written English to be below the standard expected for a scientific publication.</p>
                    <p>If the manuscript is organized in such a manner that it is illogical or not easily accessible to the reader please suggest improvements.</p>
                    <p>Please provide feedback on whether the data are presented in the most appropriate manner; for example, is a table used where a graph would provide increased clarity? Are the figures of a high enough quality to be published in their present form?</p>

                    <h4>Are there any ethical or competing interests issues you would like to raise?</h4>
                    <p>The study should adhere to the ethical standards of biomedical research, and the authors should declare that they have received ethics approval and/or patient consent for the study, where appropriate. Though we do not expect reviewers to delve into authors’ competing interests, if you are aware of any issues that you do not think have been adequately addressed, please inform the editorial office.</p>
                    <br/>
                    <h4>When to request revisions?</h4>
                    <p>Reviewers may recommend revisions for any or all of the following reasons: data need to be added to support the authors’ conclusions; better justification is needed for the arguments based on existing data; or the clarity and/or coherence of the paper needs to be improved.</p>
                    <br/>
                    <p>Reviewers are reminded of the importance of timely reviews Confidentiality</p>
                    <p>Any manuscript sent for peer review is a confidential document and should remain so until it is formally published.</p>

                    <h4>Standards of Reporting</h4>
                    <p>Reviewers are asked to adhere to the editorial standards of JournalsFeed and alert the editors if authors have not fully observed them.</p>
                    <p>JournalsFeed supports initiatives aimed at improving the reporting of research.</p>

                </div>
            </div>


            <Footer />

        </div>


    )
}

export default AuthorsReviewer